import React from 'react';
import { Package, Layers, TrendingUp, ChevronRight } from 'lucide-react';
import { NavLink } from 'react-router-dom';

interface AssetsProps {
  addNotification: (message: string, type: 'success' | 'error' | 'info' | 'warning') => void;
}

const Assets: React.FC<AssetsProps> = ({ addNotification }) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-slate-800 rounded-lg shadow-sm border border-slate-700 p-6">
        <div className="flex items-center space-x-3">
          <Package className="h-8 w-8 text-indigo-400" />
          <div>
            <h1 className="text-2xl font-bold text-slate-100">Assets</h1>
            <p className="text-slate-300 mt-1">Manage and organize your testing assets</p>
          </div>
        </div>
      </div>

      {/* Asset Categories */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Evaluation Frameworks Card */}
        <div className="bg-slate-800 rounded-lg shadow-sm border border-slate-700 p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 bg-indigo-100 rounded-lg">
              <Layers className="h-6 w-6 text-indigo-600" />
            </div>
            <h3 className="text-lg font-semibold text-slate-100">Evaluation Frameworks</h3>
          </div>
          <p className="text-slate-300 mb-4">
            Manage evaluation frameworks (RAGAS, OpenAI, etc.) and their available metrics.
          </p>
          <NavLink
            to="/assets/evaluation-frameworks"
            className="inline-flex items-center text-indigo-400 hover:text-indigo-300 font-medium group"
          >
            View Frameworks
            <ChevronRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </NavLink>
        </div>

        {/* Signal Mappings Card */}
        <div className="bg-slate-800 rounded-lg shadow-sm border border-slate-700 p-6 hover:shadow-md transition-shadow">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 bg-purple-100 rounded-lg">
              <TrendingUp className="h-6 w-6 text-purple-600" />
            </div>
            <h3 className="text-lg font-semibold text-slate-100">Signal Mappings</h3>
          </div>
          <p className="text-slate-300 mb-4">
            Configure intelligent test category recommendations based on content signals.
          </p>
          <NavLink
            to="/assets/signal-mappings"
            className="inline-flex items-center text-indigo-400 hover:text-indigo-300 font-medium group"
          >
            View Mappings
            <ChevronRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Assets;
